import { FileAttachmentList } from '@acme/foundation';
import type { FC } from 'react';
import type { Attachment } from '../../model';

export interface MessageFilesProps {
  attachments?: Attachment[] | null;
  onDownload: (id: string, fileName: string) => void;
}

export const MessageFiles: FC<MessageFilesProps> = ({
  attachments,
  onDownload,
}) => {
  return (
    <FileAttachmentList attachments={attachments} onDownload={onDownload} />
  );
};
